export { DynamicMediaSection } from './DynamicMediaSection';
